import { useState } from "react";

export default function UploadFile({ handleFileChange }) {
  const [fileName, setFileName] = useState("Upload");

  const handleFile = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const maxSize = 2 * 1024 * 1024;

    if (file.size > maxSize) {
      alert("File must be under 2MB");
      return;
    }

    setFileName(file.name);
    handleFileChange(file);
  };

  return (
    <div className="form-group file-upload">
      <label>
        Upload your avatar
        <input
          type="file"
          name="profile_image"
          accept=".jpg, .jpeg, .png"
          onChange={handleFile}
        />
        <span>{fileName}</span>
      </label>
      <p>In JPG or PNG format, not bigger than 2MB</p>
    </div>
  );
}
